// extracted by mini-css-extract-plugin
module.exports = {"section":"powerful-protection_section__ufB2i","title":"powerful-protection_title__tHiVy","container":"powerful-protection_container__3uaJ9"};